export class Itemcategory {
    itemcategoryid: number;
    itemcategoryname: string;
	active:number;
}